import { Component } from '@verndale/core';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      playButton: this.el.querySelector('.vimeo-v2__video-play-button-wrapper'),
      video: this.el.querySelector('video')
    };
  }

  addListeners() {
    this.dom.playButton.addEventListener('click', this.handlePlay.bind(this));
  }

  handlePlay() {
    this.dom.playButton.style.display = 'none';
    this.dom.video.classList.add('local-video--play');
    this.dom.video.controls = true;
    this.dom.video.play();
  }
}

export default Module;
